// extracted by mini-css-extract-plugin
export default {"container":"LineWithText_container__h3Kcw","line":"LineWithText_line__09YV-","text":"LineWithText_text__CxG9H"};